// Shared ordering for user dropdowns across the app:
// Admin → HOD → Manager → Team Leader → Employee (unknown roles last), then by name.
// Role strings may arrive in any casing/spacing ("Team Leader", "teamLeader",
// "team_leader"), so we normalize before ranking.
export const ROLE_ORDER = ['admin', 'hod', 'manager', 'teamleader', 'employee'];

export const roleRank = (role) => {
  const key = String(role || '').trim().toLowerCase().replace(/[\s_-]/g, '');
  const index = ROLE_ORDER.indexOf(key);
  return index === -1 ? ROLE_ORDER.length : index;
};

export const sortUsersByRole = (users) =>
  [...(users || [])].sort((a, b) => {
    const rankDiff = roleRank(a.role) - roleRank(b.role);
    if (rankDiff !== 0) return rankDiff;
    return String(a.name || '').localeCompare(String(b.name || ''));
  });
